import {Component, ChangeDetectionStrategy} from "@angular/core"

import {RouterOutlet} from "@angular/router"
import {JobFarmInstancesTableComponent} from "@platform/components/job-farm-instances/job-farm-instances-table/job-farm-instances-table.component"
import {SidebarLayoutComponent} from "@platform/components/layouts/sidebar-layout/sidebar-layout.component"
import {CheckboxesFilterComponent} from "@common/components/filters"
import {ItemFiltersComponent} from "@common/components/item"
import {BasePageComponent} from "@pages/base/base-page.component"
import {Labels} from "@labels"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-job-farm-instances-page",
    imports: [RouterOutlet, SidebarLayoutComponent, JobFarmInstancesTableComponent, ItemFiltersComponent, CheckboxesFilterComponent],
    templateUrl: "./job-farm-instances-page.component.html",
    styleUrl: "./job-farm-instances-page.component.scss",
})
export class JobFarmInstancesPageComponent extends BasePageComponent {
    protected readonly Labels = Labels

    readonly stateOptions = Array.from(Labels.JobFarmInstance.values())

    readonly lastSeenOptions = Array.from(Labels.LastSeen.values())
}
